export default {
  LEADS_OVERVIEW: 'Presentatie van de vooruitzichten',
  TOTAL_LEADS: 'Aantal totale vooruitzichten',
  HOT_LEADS: 'Pista calda',
  WARM_LEADS: 'Des pistas chaleureuses',
  COLD_LEADS: 'De pistas de froides',
  NO_RECORDS_FOUND: 'Nessuna descrizione trovata',
  DETAILS: 'Dettagli',
  CATEGORY: 'categoria',
  SCAN_DATE_N_TIME: 'Fecha en hora de numeración',
  FILTER: 'filtrare',
  ALL: 'Eeeek!!!',
  HOT: 'caldo',
  WARM: 'caldo',
  COLD: 'froide',
  SELECT_DATES: 'seleziona le date',
  SEARCH_LEADS: 'lead di ricerca',
  SCANNED_BY: 'scansionato da',
  FILES_INFO_SHARED: 'File e informazioni condivise',
  IMAGES: 'Immagini',
  NOTE: 'Nota',
  DELETED_FILE_MSG: 'Questo file è stato eliminato',
  LEAD_DETAILS: 'Dettagli del lead',
  ANONYMISE_DAYS: 'I dettagli dei lead saranno resi anonimi entro {days} giorni.'
}
